module.exports = __webpack_public_path__ + "static/img/icon4.8485ba77.png";